export default {
  authDomain: 'https://auth.dev.constell.com',
  apiBaseUrl: 'https://api.dev.constell.com',
  ClientId: '2tqhss3v70h8tb96j8ollc2ckt',
}
